/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import { Container } from './style';
import Input from '../input/input';

import * as Sebrae from '@sebrae/react-core';
import { FormContext } from '../../hook/form-context';
import { useDisplay } from '../../hook/useDisplay';
import { BaSeHeading5 } from '@base/react';

function FormPersonalData({ handleChangePersonalData, personalData }) {
  const { isAuthenticated } = Sebrae.useAuth();
  const { formatCpf } = React.useContext(FormContext);
  const { breakpointController } = useDisplay();

  const returnMessage =
    breakpointController.inMobile || breakpointController.inMobileLarge ? (
      <BaSeHeading5 color={'#fff'}>Informe os seus dados pessoais</BaSeHeading5>
    ) : (
      <></>
    );

  return (
    <>
      {returnMessage}
      <Container>
        <Input
          value={personalData.name}
          placeholder="Preencha seu nome completo"
          label="Nome:"
          onChange={(e) => handleChangePersonalData('name', e.target.value)}
          isDisabled={isAuthenticated}
        />
        <Input
          value={personalData.cpf}
          placeholder="Preencha seu CPF"
          label="CPF:"
          onChange={(e) => {
            const formattedValue = formatCpf(e.target.value);
            if (formattedValue.length > 14) return;
            handleChangePersonalData('cpf', formattedValue);
          }}
          isDisabled={isAuthenticated}
        />
        <Input
          value={personalData.email}
          type="email"
          placeholder="Preencha seu melhor e-mail"
          label="E-mail:"
          onChange={(e) => handleChangePersonalData('email', e.target.value)}
        />
        <Input
          value={personalData.contato}
          placeholder="DDD + telefone"
          label="Contato:"
          onChange={(e) => {
            const rawValue = e.target.value.replace(/\D/g, '');

            let formattedValue = '';
            if (rawValue.length <= 10) {
              formattedValue = rawValue.replace(
                /(\d{2})(\d{4})(\d{0,4})/,
                '($1) $2-$3',
              );
            } else {
              formattedValue = rawValue.replace(
                /(\d{2})(\d{5})(\d{0,4})/,
                '($1) $2-$3',
              );
            }

            if (formattedValue.length > 15) return;
            handleChangePersonalData('contato', formattedValue);
          }}
        />
      </Container>
    </>
  );
}

export default FormPersonalData;
